import React from 'react';
import { Typography } from '@chegg-ui/typography';
import { Checkbox } from '../Shared/Checkbox';
import { FieldType } from './constants';
import { SectionRow } from '../Shared/styled';
import { Section, Input, RadioGroup } from '../Shared';
import { PubDate } from '../Shared/PubDate';
import { RadioGroupWithInput } from '../Shared/RadioGroupWithInput';
import { CheckBoxGroupWithInput, CheckBoxLabel } from './styled';
export var getField = function getField(props) {
  var name = props.name,
    field = props.field,
    selectedTab = props.selectedTab;
  var FIELD_NAME_FOR_FORMIK_STATE = "".concat(name, ".").concat(field.field);
  var UNIQUE_KEY_FOR_FIELD = selectedTab ? "".concat(selectedTab, ".").concat(name, ".").concat(field.field) : FIELD_NAME_FOR_FORMIK_STATE;
  var DATA_TEST_ID = field.field;
  var LABEL_TEXT = field.labelText;
  var LABEL_TEXT_BOLD = field.labelTextBold;
  switch (field.type) {
    case FieldType.CHECKBOX:
      return /*#__PURE__*/React.createElement(Checkbox, {
        key: UNIQUE_KEY_FOR_FIELD,
        name: FIELD_NAME_FOR_FORMIK_STATE,
        inputId: UNIQUE_KEY_FOR_FIELD,
        "data-test": DATA_TEST_ID
      }, LABEL_TEXT);
    case FieldType.LABEL:
      return /*#__PURE__*/React.createElement(Typography, {
        key: UNIQUE_KEY_FOR_FIELD,
        variant: "body1",
        tag: "span",
        display: "inline-flex",
        "data-test": DATA_TEST_ID
      }, LABEL_TEXT);
    case FieldType.CHECKBOX_WITH_LABEL:
      return /*#__PURE__*/React.createElement(CheckBoxGroupWithInput, null, /*#__PURE__*/React.createElement(CheckBoxLabel, null, LABEL_TEXT_BOLD), /*#__PURE__*/React.createElement(Checkbox, {
        key: UNIQUE_KEY_FOR_FIELD,
        name: FIELD_NAME_FOR_FORMIK_STATE,
        inputId: UNIQUE_KEY_FOR_FIELD,
        "data-test": DATA_TEST_ID
      }, LABEL_TEXT));
    case FieldType.RADIO:
      return /*#__PURE__*/React.createElement(RadioGroup, {
        key: UNIQUE_KEY_FOR_FIELD,
        name: UNIQUE_KEY_FOR_FIELD,
        formikFieldName: FIELD_NAME_FOR_FORMIK_STATE,
        options: field.options,
        legend: LABEL_TEXT,
        align: field.alignment,
        "data-test": field.dataTestId,
        defaultSelectedIndex: field.defaultSelectedIndex
      });
    case FieldType.RADIO_GROUP_WITH_INPUT:
      return /*#__PURE__*/React.createElement(RadioGroupWithInput, {
        key: UNIQUE_KEY_FOR_FIELD,
        inputName: field.inputName,
        radioName: "".concat(selectedTab, ".").concat(field.radioName),
        radioFormikName: field.radioName,
        options: field.options,
        legend: LABEL_TEXT,
        align: field.alignment,
        "data-test": field.dataTestId,
        changeOptionOnInputFocus: field.changeOptionOnInputFocus,
        defaultSelectedIndex: field.defaultSelectedIndex
      });
    case FieldType.PUBDATE:
      return /*#__PURE__*/React.createElement(PubDate, {
        key: UNIQUE_KEY_FOR_FIELD,
        labelText: LABEL_TEXT,
        "data-test": DATA_TEST_ID,
        formikFieldNames: field.formikFieldNames.map(function (fieldName) {
          return "".concat(name, ".").concat(fieldName);
        })
      });
    case FieldType.TEXT:
    default:
      return /*#__PURE__*/React.createElement(Input, {
        key: UNIQUE_KEY_FOR_FIELD,
        className: field.field,
        name: FIELD_NAME_FOR_FORMIK_STATE,
        labelText: LABEL_TEXT,
        flexSize: field.flex || '1',
        "data-test": DATA_TEST_ID,
        isRecommended: field.recommended,
        placeholder: field.placeholderText || '',
        helperText: field.helperText
      });
  }
};
export var fieldIsRow = function fieldIsRow(field) {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return field.fields !== undefined;
};
export var GenericSection = function GenericSection(_ref) {
  var sectionTitle = _ref.sectionTitle,
    name = _ref.name,
    fieldList = _ref.fieldList,
    dataTestId = _ref['data-test'],
    selectedTab = _ref.selectedTab;
  return /*#__PURE__*/React.createElement(Section, {
    className: "wf-generic-section",
    sectionId: '',
    title: sectionTitle,
    ariaLabelledby: '',
    dataTestId: dataTestId
  }, fieldList.map(function (field, index) {
    if (fieldIsRow(field)) {
      return /*#__PURE__*/React.createElement(SectionRow, {
        key: index,
        className: field.rowtype
      }, field.fields.map(function (rowField) {
        return getField({
          name: name,
          field: rowField,
          selectedTab: selectedTab
        });
      }));
    } else {
      return getField({
        name: name,
        field: field,
        selectedTab: selectedTab
      });
    }
  }));
};
export default GenericSection;